import * as React from 'react'
import {FC} from 'react'
import {FormInstance} from 'antd/lib/form'
import Contacts from '../contacts'
import {Row, Col} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import GlobalOptionsInterface from '../../types/global-options'

interface ContactParamsPropsInterface {
    form: FormInstance
    globalOptions: GlobalOptionsInterface
}

const ContactParams: FC<ContactParamsPropsInterface> = ({form, globalOptions}) => {
    return (
        <div className='e-smart-padding-left'>
            <Contacts form={form} globalOptions={globalOptions} />
        </div>
    )
}

export default ContactParams
